import { Util } from '../../../common/util/util';
import { IMainCatalogItem } from '../../../shared/types/main-catalog';

export const getProcesses = (
  processes: IMainCatalogItem[] = [],
  windowWidth: number
) => {
  const content: IMainCatalogItem[] = [];
  let width = 50;
  for (let i = 0; i < processes?.length; i++) {
    if (
      Util.getTextWidth(processes[i]?.title, '14px open sans') + 70 + width <
      windowWidth
    ) {
      width += 70 + Util.getTextWidth(processes[i]?.title, '14px open sans');
      content.push(processes[i]);
    } else {
      return { content, processesLeft: processes?.slice(i, processes?.length) };
    }
  }

  return { content, processesLeft: [] };
};
